const pageTitle = {
  'Google Merchant Center': 'Google Merchant Center - การตั้งค่า Shopping Ads',
};

export default pageTitle;
